import React, { useEffect, useState } from 'react'
import TextFieldUniversal from '../../../../../validate/form/text/TextFieldUniversal'

const SeriesOneAnotherSeries = ({ required, setValidate, setValueForm, forciblyValue }) => {

  	const [value, setValue] = useState('')

  return (
	<TextFieldUniversal
        value={value}
        setValue={e => {
            setValueForm(e)
            setValue(e)
        }}
        setValidate={setValidate}
        label={'Серія товару (зовнішня)'} 
        placeholder={'Введіть серію'}
        validates={{
            isEmpty: true,
        }}
        forciblyValue={forciblyValue}
        required={required}
    />
  )
}

export default SeriesOneAnotherSeries